module.exports = __webpack_public_path__ + "static/media/QH.0f61461f.svg";